import * as actionTypes from "./actionTypes";

export const authorizeValidation = (isAuthBool) => {
  return {
    type: actionTypes.AUTHORIZE_VALIDATION,
    payload: {
      isAuth: isAuthBool,
    },
  };
};

export const setMunicipalityId = (id) => {
  return {
    type: actionTypes.SET_MUNICIPALITY_ID,
    payload: {
      municipalityId: id,
    },
  };
};

export const setPassword = (isTemporaryBool) => {
  return {
    type: actionTypes.SET_ISTEMPORARY,
    payload: {
      isTemporary: isTemporaryBool,
    },
  };
};

export const setUsernameDesc = (desc) => {
  return {
    type: actionTypes.SET_USERNAME_DESC,
    payload: {
      UsernameDesc: desc,
    },
  };
};

export const setIsReloaded = () => {
  return {
    type: actionTypes.SET_ISRELOADED,
    payload: {
      isReloaded: true,
    },
  };
};
